import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";


export const activeGenerationStatuses = ["queued", "running"];

export function useLatestContentGeneration() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["content-generation", user.user_id],
    queryFn: () => api.get("/content/generations/latest").then((response) => response.data),
    refetchInterval: (query) => activeGenerationStatuses.includes(query.state.data?.status) ? 1500 : 15000,
  });
}

export function useStartContentGeneration() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => api.post("/content/generations", payload).then((response) => response.data),
    onSuccess: (job) => queryClient.setQueryData(["content-generation", user.user_id], job),
  });
}